import styled from '@emotion/styled';
export var FormSection = styled.section({
  display: 'grid',
  gridTemplateRows: 'auto',
  gridTemplateColumns: 'auto',
  textAlign: 'left',
  '& > *': {
    gridArea: '1/1'
  }
});